import { ServiceManager, ServiceBusController, ServiceBusControllerBody } from '@estee/elc-service';
import {
    events,
    on,
    queryProvider,
    serviceQueries,
    serviceCommands,
    commandProvider
} from '@estee/elc-service-bus';

const queries = [[serviceQueries.GET_REVIEW_SNIPPET, 'getReviewSnippets']];

const commands = [[serviceCommands.UPDATE_POWER_REVIEWS_CONFIGS, 'updateReviewConfig']];

const onEvents = [
    [events.SPP_POWER_REVIEWS_INIT, 'powerReviewsInitialized'],
    [events.READ_REVIEWS_LINK_CLICKED, 'readReviewsLinkClicked'],
    [events.WRITE_REVIEWS_LINK_CLICKED, 'writeReviewsLinkClicked'],
    [events.PRODUCT_FULL_LOADED, 'productFullLoaded']
];

export class ServiceBus extends ServiceBusController {
    @on(events.ECOMM_STARTED, { replay: true })
    public onEcommStarted = () => {
        const id = setInterval(() => {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            if (serviceBusBaseClass) {
                clearInterval(id);
                queries.forEach(ServiceManager.setDecoratorOnFunction(queryProvider));
                commands.forEach(ServiceManager.setDecoratorOnFunction(commandProvider));
                onEvents.forEach(ServiceManager.setDecoratorOnFunction(on));
            }
        }, 50);
    };
}

// @ts-ignore
export const serviceBusBaseClass = new ServiceBus() as ServiceBusController &
    ServiceBusControllerBody;
